export default "__VITE_ASSET__526c3388__"